export default __webpack_public_path__ + "static/media/SALT.e6e562f0.svg";